/* eslint-disable react/jsx-no-target-blank */
import clsx from 'clsx';
import { useLayout } from 'layouts/core/layout.context';
import { FC } from 'react';

const Footer: FC = () => {
  const { classes } = useLayout();
  return (
    <div className={'footer py-4 d-flex flex-lg-column'} id="kt_footer">
      {/* begin::Container */}
      <div className={clsx(classes.footerContainer, 'd-flex flex-column flex-md-row flex-stack')}>
        {/* begin::Copyright */}
        <div className="text-dark order-2 order-md-1">
          <span className="text-gray-400 fw-bold me-1">Advance Motors</span>
        </div>
        {/* end::Copyright */}

        {/* begin::Menu */}
        <ul className="menu menu-gray-600 menu-hover-primary fw-bold order-1">
          <li className="menu-item">
            <a href="#" target="_blank" className="menu-link px-2">
              About
            </a>
          </li>

          <li className="menu-item">
            <a href="#" target="_blank" className="menu-link px-2">
              Support
            </a>
          </li>
        </ul>
        {/* end::Menu */}
      </div>
      {/* end::Container */}
    </div>
  );
};

export { Footer };
